export const TABLE = {
  CSV: 1,
  BACKEND: 2,
};

export const columnTitles = [
  {
    title: 'Mã đặt xe',
    dataIndex: 'book_code',
  },
  {
    title: 'Thông tin khách hàng',
    dataIndex: 'cstm_name',
  },
  {
    title: 'Ngày tạo',
    dataIndex: 'book_crta',
  },
  {
    title: 'Ngày nhận',
    dataIndex: 'book_rental_date_actual',
  },
  {
    title: 'Ngày trả',
    dataIndex: 'book_return_date_actual',
  },

  {
    title: 'Loại xe',
    dataIndex: 'vhc_type_name',
  },

  {
    title: 'Tổng tiền',
    dataIndex: 'book_prie_tota',
  },
  {
    title: 'Tổng tiền thực tế',
    dataIndex: 'book_price_total_actual',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Chi tiết',
    dataIndex: 'detail',
  },
];
